import { CacheKeys } from 'utils/cacheKeys';
import { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import { queryClient } from 'providers/AllProviders';

type BusinessContextType = {
  selectedBusiness: number | null;
  setSelectedBusiness: (business: number | null) => void;
  selectedWorkspace: number | null;
  setSelectedWorkspace: (business: number | null) => void;
};

const BusinessContext = createContext<BusinessContextType | undefined>(undefined);

type BusinessProviderProps = {
  children: ReactNode;
};

export const BusinessProvider = ({ children }: BusinessProviderProps) => {
  let businessIds;
  if (localStorage.getItem(CacheKeys.businessIds)) {
    businessIds = JSON.parse(localStorage.getItem(CacheKeys.businessIds) ?? '');
  }
  const selectFirstBusinessDefault = businessIds?.length > 0 ? businessIds[0] : null;
  const [selectedBusiness, setSelectedBusiness] = useState<number | null>(selectFirstBusinessDefault);

  useEffect(() => {
    queryClient.resetQueries();
  }, [selectedBusiness]);

  let workspaceIds;
  if (localStorage.getItem(CacheKeys.workspaceIds)) {
    workspaceIds = JSON.parse(localStorage.getItem(CacheKeys.workspaceIds) ?? '');
  }
  const selectFirstWorkSpaceDefault = workspaceIds?.length > 0 ? workspaceIds[0] : null;
  const [selectedWorkspace, setSelectedWorkspace] = useState<number | null>(selectFirstWorkSpaceDefault);

  return (
    <BusinessContext.Provider
      value={{
        selectedBusiness,
        setSelectedBusiness,
        selectedWorkspace,
        setSelectedWorkspace
      }}
    >
      {children}
    </BusinessContext.Provider>
  );
};

export const useBusiness = () => {
  const context = useContext(BusinessContext);
  if (!context) {
    throw new Error('useBusiness must be used within a BusinessProvider');
  }
  return context;
};
